import Component from 'flarum/common/Component';
import Select from 'flarum/common/components/Select';
import Button from 'flarum/common/components/Button';

export default class MinifigDecoder extends Component {
    private scanner: any;
    private showTable: boolean = false;
    private result: string = '';
    private selectedRegion: string = '0';
    private selectedSeries: string = '25';
    private isScanning: boolean = false;

    // Minifigures data organized by series
    private figData = {
        '25': {
            "Barbarian": [59,60,93, "https://assets.brickzip.com/pages/minifig-scanner/series-25/Barbarian.png"],
            "Fitness Trainer": [60,61,94, "https://assets.brickzip.com/pages/minifig-scanner/series-25/Fitness_Trainer.png"],
            "Mushroom Sprite": [61,62,95, "https://assets.brickzip.com/pages/minifig-scanner/series-25/Mushroom_Sprite.png"],
            "Goatherd": [62,63,96, "https://assets.brickzip.com/pages/minifig-scanner/series-25/Goatherd.png"],
            "Harpy": [63,64,97, "https://assets.brickzip.com/pages/minifig-scanner/series-25/Harpy.png"],
            "Train Kid": [64,65,98, "https://assets.brickzip.com/pages/minifig-scanner/series-25/Train_Kid.png"],
            "Film Noir Detective": [65,66,99, "https://assets.brickzip.com/pages/minifig-scanner/series-25/Film_Noir_Detective.png"],
            "Sprinter": [66,67,100, "https://assets.brickzip.com/pages/minifig-scanner/series-25/Sprinter.png"],
            "Pet Groomer": [67,68,101, "https://assets.brickzip.com/pages/minifig-scanner/series-25/Pet_Groomer.png"],
            "Tricertops Costume Fan": [68,69,102, "https://assets.brickzip.com/pages/minifig-scanner/series-25/Tricertops_Costume_Fan.png"],
            "Black Falcon Gamer Girl": [69,70,103, "https://assets.brickzip.com/pages/minifig-scanner/series-25/Falcon_Gamer_Girl.png"],
            "Vampire Knight": [70,71,104, "https://assets.brickzip.com/pages/minifig-scanner/series-25/Vampire_Knight.png"],
        },
        '26': {
            // Add Series 26
            "Black Falcon Gamer Girl": [69,70,103, "https://assets.brickzip.com/pages/minifig-scanner/series-25/Falcon_Gamer_Girl.png"],
            "Vampire Knight": [70,71,104, "https://assets.brickzip.com/pages/minifig-scanner/series-25/Vampire_Knight.png"],
            // ... more figures
        }
    };

    oncreate(vnode) {
        super.oncreate(vnode);
        // Load the QR scanner script
        const script = document.createElement('script');
        script.src = 'https://cdnjs.cloudflare.com/ajax/libs/html5-qrcode/2.3.4/html5-qrcode.min.js';
        script.onload = () => {
            this.initScanner();
        };
        document.head.appendChild(script);
    }

    onremove(vnode) {
        super.onremove(vnode);
        if (this.scanner) {
            this.scanner.clear();
        }
    }

    initScanner() {
        const Html5QrcodeScanner = (window as any).Html5QrcodeScanner;
        
        if (!this.isScanning) {
            this.scanner = new Html5QrcodeScanner("reader", {
                qrbox: {
                    width: 250,
                    height: 250,
                },
                fps: 20,
            });

            this.scanner.render(
                (result: string) => this.handleSuccess(result),
                (error: any) => this.handleError(error)
            );
            
            this.isScanning = true;
        }
    }

    handleSuccess(result: string) {
        this.result = result;
        
        const lastTwoDigits = result
            .split(" ")[0]
            .slice(-2)
            .replace(/^0+/, "");

        if (this.selectedRegion === '0') {
            this.result = 'Please select a region';
            m.redraw();
            return;
        }

        const regionIndex = parseInt(this.selectedRegion) - 1;
        const currentSeries = this.figData[this.selectedSeries];
        
        for (const [key, value] of Object.entries(currentSeries)) {
            if (value[regionIndex] == parseInt(lastTwoDigits)) {
                this.result = `
                    <h2>Success!</h2>
                    <p>${result}</p>
                    <p>${key}</p>
                    <img src="${value[3]}" style="width: 150px; height: auto;">
                `;
                break;
            }
        }

        if (this.scanner) {
            this.scanner.clear();
            this.isScanning = false;
        }

        m.redraw();
    }

    handleError(error: any) {
        console.error(error);
    }

    view() {
        return m('.MiniFigDecoder', [
            m('h1', 'Lego Mini-Figure Decoder'),
            
            m('p', 'Choose your series and region, then scan the QR code on the Mini-Fig Packet. Use Ultra-Wide Camera on IPhone for best results.'),
            
            // Series selection
            m('.Form-group', [
                Select.component({
                    value: this.selectedSeries,
                    onchange: (value: string) => {
                        this.selectedSeries = value;
                        this.result = '';
                    },
                    options: {
                        '25': 'Series 25',
                        '26': 'Series 26',
                    },
                }),
            ]),

            // Region selection
            m('.Form-group', [
                Select.component({
                    value: this.selectedRegion,
                    onchange: (value: string) => {
                        this.selectedRegion = value;
                        this.result = '';
                    },
                    options: {
                        '0': 'Select Region',
                        '1': 'North America',
                        '2': 'Europe',
                        '3': 'Denmark',
                    },
                }),
            ]),

            m('#reader.qr-reader'),
            m('#result.qr-result'),

            this.result && m('.result', m.trust(this.result)),

            !this.isScanning && this.result && Button.component({
                className: 'Button Button--primary',
                onclick: () => {
                    this.result = '';
                    this.initScanner();
                }
            }, 'Scan Another'),

            Button.component({
                className: 'Button',
                onclick: () => {
                    this.showTable = !this.showTable;
                },
            }, 'i'),

            this.showTable && m('.tables-container', [
                Object.entries(this.figData).map(([series, figures]) => 
                    m('.series-table', [
                        m('h3', `Series ${series}`),
                        m('table.fig-table', [
                            m('tr', [
                                m('th', 'Minifigure'),
                                m('th', 'Europe'),
                                m('th', 'North America'),
                                m('th', 'Denmark'),
                                m('th', 'Image'),
                            ]),
                            Object.entries(figures).map(([key, value]) => 
                                m('tr', [
                                    m('td', key),
                                    m('td', value[0]),
                                    m('td', value[1]),
                                    m('td', value[2]),
                                    m('td', m('img', {
                                        src: value[3],
                                        style: 'width: 100px; height: auto;'
                                    })),
                                ])
                            ),
                        ]),
                    ])
                )
            ]),
        ]);
    }
}
